import axios from 'axios';
import API_BASE_URL from '../config.js';

const RegisterUserEvent = async (token, userEvent) => {
    try {
        const response = await axios.post(`${API_BASE_URL}api/register-user-event/`, 
        userEvent, 
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        return response; // Devuelve la respuesta completa
    } catch (error) {
        if (error.response) {
            throw error.response; // Lanza la respuesta completa en caso de error
        } else {
            throw error; // Lanza el error completo si no hay respuesta
        }
    }
}

export default RegisterUserEvent;
